export default __webpack_public_path__ + "static/m-portfolio3-186944411442586644415c58e337fde7.jpg";